var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chart',{ref:"barChart",staticStyle:{"width":"90%","height":"230px","margin-bottom":"20px","margin-left":"auto","margin-right":"auto","margin-top":"0"},attrs:{"option":_vm.barChartData}})}
var staticRenderFns = []

export { render, staticRenderFns }